<template lang='pug'>
  v-flex(:class="classObj", :title='label', :id="id")
    v-label {{ label }}
    br
    br
    .text-xs-center
      input.d-none(ref='inputImage' type="file" @change="onDetectFiles($event.target.files[0])")
      a(@click='onSelectImage')
        v-avatar.mb-3(:size='200' color='grey lighten-4')
          v-img(v-if='urlImage' :src='urlImage')
          .title(v-else) Sem Imagem
      .text-xs-center.pt-2(v-if='urlImage')
        v-btn(color='error' @click='onRemove') remover
</template>

<script>
import fileUtils from '@/utils/file'
import Axios from 'axios'

export default {
  name: 'u-upload',

  props: {
    id: {
      type: String
    },
    component: {
      type: Object,
      required: true
    },
    value: {}
  },

  watch: {
    value: {
      handler: function (val) {
        this.urlImage = val
      },
      deep: true
    }
  },

  computed: {
    label () {
      return this.t(this.id + '.label', this.component.label)
    }
  },

  data () {
    return {
      data: null,
      file: null,
      urlImage: ''
    }
  },

  methods: {
    onRemove () {
      this.file = null
      this.$refs.inputImage.value = null
      this.$emit('input', null)
    },
    async onDetectFiles (file) {
      this.file = file
      const imgBase64 = await fileUtils.getBase64(file)
      this.$emit('input', imgBase64)
    },
    onSelectImage () {
      this.$refs.inputImage.click()
    },
    onUploadImage () {
      return new Promise(async (resolve, reject) => {
        if (!this.file) return resolve(null)

        const base64 = await this.readFileAsBase64(this.file)
        const url = 'https://us-central1-ultracarebr.cloudfunctions.net/processImage'
        const payload = { image: base64, storageRef: 'signatures', fileName: this.file.name }
        const result = await Axios.post(url, payload)
        if (result && result.data) {
          resolve(result.data.downloadURL)
        } else {
          resolve(null)
        }
        /* const storageRef = storage.ref().child(`${this.component.storageRef || ''}/${new Date().getTime()}_${this.file.name}`)
        const uploadTask = storageRef.put(this.file)

        uploadTask.on('state_changed', (snapshot) => {
          const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100
          console.log(progress)
        }, error => {
          reject(error)
        }, () => {
          uploadTask.snapshot.ref.getDownloadURL().then((downloadURL) => {
            resolve(downloadURL)
          })
        }) */
      })
    },
    readFileAsBase64 (file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        // Dispara quando a leitura do arquivo for concluída
        reader.onload = () => {
          resolve(reader.result)
        }
        // Dispara em caso de erro na leitura do arquivo
        reader.onerror = (error) => {
          reject(error)
        }
        // Lê o arquivo como uma string Base64
        reader.readAsDataURL(file)
      })
    }
  }
}
</script>

<style lang='stylus' scoped>
</style>



// WEBPACK FOOTER //
// src/components/form/inputs/Upload.vue